import { BlogHero } from '@/root/../../packages/ui-lib/src/modules/blogEducation/blogHero/BlogHero';
import { t } from '@lingui/macro';
import { NextSeo } from 'next-seo';
import { useContext } from 'use-context-selector';
import { Breadcrumbs } from 'components/breadcrumbs/Breadcrumbs';
import { NailArtLandingContext } from '../nailArtLandingProvider/NailArtLandingProvider';

export const NailArtHeaderConnected = () => {
  const nailArtLandingContext = useContext(NailArtLandingContext);

  if (nailArtLandingContext === undefined) {
    throw new Error(
      'NailArtHeaderConnected must be used within a NailArtLandingContext'
    );
  }

  const { hero, seo, title } = nailArtLandingContext;

  return (
    <>
      <Breadcrumbs
        title={t({
          id: 'breadcrumbs.nailArt',
          message: 'Nail Art',
        })}
      />
      <NextSeo
        title={seo?.title ?? title}
        description={seo?.description ?? ''}
      />
      {hero && <BlogHero {...hero} />}
    </>
  );
};
